<template>
  <div class="bread-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: item.path }" v-for="(item,index) in matched" :key="index">{{item.meta.title}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
    data(){
        return{
            matched:[]
        }
    },
    created(){
        this.initData()
    },
    methods:{
        initData(){
            let matched = this.$route.matched
            this.matched = matched
            // console.log(matched,"router对象")
        }
    }
}
</script>
<style lang="scss" scoped>

</style>